module.exports = __webpack_public_path__ + "static/img/icon_drawer.16fc27f1.png";